export default "__VITE_ASSET__2ec29966__"